import React, { useMemo, useState } from 'react';
import _ from 'lodash';
import { Label } from 'semantic-ui-react';
import { formatItem, formatTypes } from 'global/common/dateFormatting';

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const _monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'Decemeber']

const normalizeMonth = (month) => {
  if (_.isDate(month)) return new Date(month.getFullYear(), month.getMonth(), 1);
  if (_.isString(month)) {
    const [y, m] = month.split('-');
    return new Date(Number(y), Number(m) - 1, 1);
  }
  throw new Error('Invalid month prop');
};

const buildCalendarDays = (monthDate) => {
  const startOfMonth = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
  const endOfMonth = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0);

  const startDay = startOfMonth.getDay(); // Sunday = 0
  const totalDays = endOfMonth.getDate();

  // Days from previous month
  const prevDays = _.range(startDay).map((i) => {
    const d = new Date(startOfMonth);
    d.setDate(d.getDate() - (startDay - i));
    return { date: d, currentMonth: false };
  });

  // Days in current month
  const currDays = _.range(1, totalDays + 1).map((day) => ({
    date: new Date(monthDate.getFullYear(), monthDate.getMonth(), day),
    currentMonth: true
  }));

  // Fill to complete weeks
  const totalCells = Math.ceil((prevDays.length + currDays.length) / 7) * 7;
  const nextDaysCount = totalCells - (prevDays.length + currDays.length);

  const nextDays = _.range(nextDaysCount).map((i) => {
    const d = new Date(endOfMonth);
    d.setDate(endOfMonth.getDate() + i + 1);
    return { date: d, currentMonth: false };
  });

  return _.chunk([...prevDays, ...currDays, ...nextDays], 7);
};

const dateItems = (items, date) => {
  const d = formatItem(formatTypes.shortestDate, date)
  const count = items[d]?.count || 0
  return <div style={{ textAlign: 'center', alignContent: 'center', justifySelf: 'center', padding: '1em', height: '100%' }}><Label color={count > 0 ? 'blue' : 'grey'}>{count}</Label></div>
}

export const MonthCalendars = ({ appUserAuthUsageData }) => {

  const _typeKeys = _.keys(appUserAuthUsageData)

  const [currentKey, setCurrentKey] = useState(_typeKeys[0])

  const handleCurrentKey = (key) => setCurrentKey(key)

  const labels = useMemo(() => {
    return _.map(_typeKeys, (key) => {
      return <div><Label color={key === currentKey ? 'blue' : 'grey'} onClick={() => handleCurrentKey(key)}>{_.startCase(key)}</Label></div>
    })
  }, [_typeKeys])

  const calMonth = useMemo(() => {
    const _calInfo = appUserAuthUsageData?.[currentKey]
    const cms = []
    if (_calInfo?.startDates.lastRefresh) {
      _.forEach(_calInfo.startDates.lastRefresh, (sd) => {
        const d = new Date(sd)
        cms.push(<MonthCalendar month={new Date(d.getFullYear(), d.getMonth(), 1)} items={_calInfo.authDates.lastRefresh} />)
      })
    }
    if (_.isEmpty(_calInfo.startDates.lastRefresh)) {
      cms.push(<div style={{ padding: '1em' }}>None</div>)
    }

    return cms
  }, [currentKey])

  return <div style={{ display: 'flex', flexDirection: 'column' }}>
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', padding: '1em', backgroundColor: 'var(--off-black-3)', borderRadius: '8px' }}>{labels}</div>
    <div>{calMonth}</div>
  </div>


}

const MonthCalendar = ({ month, items, appUserAuthTotals, appUserAuthUsageData }) => {

  const monthDate = normalizeMonth(month);
  const weeks = buildCalendarDays(monthDate);

  const monthIndex = month.getMonth()
  const monthName = _monthNames[monthIndex]
  const year = month.getFullYear();

  return (
    <div className='cal-month app-dark-mode' style={{ display: 'flex', flexDirection: 'column' }}>
      <div className='cal-month-header' style={{ textAlign: 'center', padding: '1em', border: '1px solid var(--off-black-3)', width: '100%', }}>
        {`${monthName} ${year}`}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
        {DAYS.map((d) => (
          <div key={d} style={{ textAlign: 'center', padding: '1em', border: '1px solid var(--off-black-3)', width: '100%', }}>
            {d}
          </div>
        ))}
      </div>
      <div>
        {weeks.map((week, wi) => (
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
            {week.map(({ date, currentMonth }, di) => (
              <div key={di}
                style={{
                  height: '100%',
                  width: '100%',
                  padding: '.25em',
                  border: '1px solid var(--off-black-3)',
                  background: currentMonth ? 'var(--off-black-2)' : 'var(--off-black-3)'
                }}
              >
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <div style={{ textAlign: 'left', fontWeight: 600 }}>{date.getDate()}</div>
                  {dateItems(items, date)}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthCalendar;
